import * as React from 'react';
import { AppBar, UserMenu, Logout, useGetIdentity } from 'react-admin';
import { Box, useTheme, alpha, Typography, Chip, IconButton, Tooltip } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeIcon from '@mui/icons-material/LightModeOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Logo } from '../assets/logo';

const CustomUserMenu = () => (
  <UserMenu>
    <Logout />
  </UserMenu>
);

const CustomAppBar = ({ oscuro = false, alternarOscuro = null, ...props }) => {
  const theme = useTheme();
  const { identity } = useGetIdentity();
  const isCreditorView = process.env.REACT_APP_VIEW === 'creditor';
  
  return (
    <AppBar
      color="default"
      elevation={0}
      sx={{
        backgroundColor: alpha(theme.palette.background.paper, 0.95),
        backdropFilter: 'blur(6px)',
        borderBottom: 1,
        borderColor: alpha(theme.palette.primary.main, 0.1),
        // La barra va fija y el contenido arranca a una altura fija (48/56 px);
        // si algo de dentro la hace crecer, tapa el primer menú de la izquierda
        // ("Bank Cases", André 28/08). Se le pone tope y nada se parte en dos
        // líneas.
        '& .MuiToolbar-root': {
          minHeight: { xs: 48, sm: 56 },
          height: { xs: 48, sm: 56 },
          flexWrap: 'nowrap',
        },
        '& .RaAppBar-title, & .RaUserMenu-userButton': {
          whiteSpace: 'nowrap',
        },
      }}
      userMenu={<CustomUserMenu />}
      {...props}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        px={2}
        sx={{ flex: 1, minWidth: 0, overflow: 'hidden' }}
      >
        <Box 
          sx={{ 
            height: 40,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Logo height={40} />
        </Box>
        
        {isCreditorView && (
          <Chip
            icon={<AccountBalanceIcon />}
            label="Creditor Portal"
            color="primary"
            size="small"
            sx={{ ml: 2 }}
          />
        )}
        
        {/* Interruptor de claro/oscuro (André, 28/08). No aparece en el portal
            de acreedores, que es de cara al cliente. */}
        {alternarOscuro && (
          <Tooltip title={oscuro ? 'Modo claro' : 'Modo oscuro'}>
            <IconButton onClick={alternarOscuro} size="small" sx={{ ml: 'auto', color: 'text.secondary' }}>
              {oscuro ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
            </IconButton>
          </Tooltip>
        )}

        {identity && identity.fullName && (
          <Typography 
            variant="body2" 
            color="textSecondary"
            noWrap
            sx={{
              ml: alternarOscuro ? 1 : 'auto',
              mr: 2,
              display: { xs: 'none', sm: 'block' }
            }}
          >
            {isCreditorView ? 'Creditor: ' : 'User: '}
            <Box component="span" fontWeight="bold">
              {identity.fullName}
            </Box>
          </Typography>
        )}
      </Box>
    </AppBar>
  );
};

export default CustomAppBar;
